import $ from "jquery";
// import "@fancyapps/fancybox";
import { Fancybox } from "@fancyapps/ui";
import Swiper from "swiper/bundle";
import "./menu";
import "magnific-popup";

$(function ($) {
  // jQuery ("input = 'tel']"). Mask ("+38 (099) 999-99-99");
  // Checking the number of slides
  function initSwiperWithLoopCheck(selector, options) {
    if (!document.querySelector(selector)) return null;
    const totalSlides = $(selector).find(".swiper-slide").length;
    options.loop = totalSlides > options.slidesPerView;
    return new Swiper(selector, options);
  }

  if (document.querySelector(".hero-slider-container")) var heroSwiper = new Swiper(".hero-slider-container", {
    // Optional parameters
    direction: "horizontal",
    loop: true,
    autoplay: {
      delay: 6000, // 6 seconds
      disableOnInteraction: false, // keeps autoplay active even after interaction
    },

    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    // Pagination (dots)
    pagination: {
      el: ".hero-swiper-pagination",
      clickable: true, // Makes the dots clickable
    },
  });

  const gallerySwiper = initSwiperWithLoopCheck(".swiper-gallery", {
    slidesPerView: 4, // Display 4 slides at the same time
    spaceBetween: 0, // No space between slides
    loop: true, // Infinite loop for the carousel
    navigation: {
      nextEl: ".swiper-button-next", // Next button for navigation
      prevEl: ".swiper-button-prev", // Previous button for navigation
    },
    autoplay: {
      delay: 6000, // Slide changes every 5 seconds
      disableOnInteraction: false, // Autoplay continues even after user interaction
    },
    // pagination: {
    //     el: '.swiper-pagination',  //Pagination element (dots)
    //     clickable: true,  //Makes the dots clickable for navigation
    // },
    breakpoints: {
      1024: {
        slidesPerView: 4, // 4 slides visible for screens larger than 1024px
      },
      769: {
        slidesPerView: 3, // 3 slides visible for screens between 768px and 1024px
      },
      600: {
        slidesPerView: 2, // 3 slides visible for screens between 360px and 768px
      },
      320: {
        slidesPerView: 1, // 3 slides visible for screens between 360px and 768px
      },
    },
    on: {
      init: function () {
        // Called when Swiper is initialized
        addActiveClass(this);
      },
      slideChange: function () {
        // Called when the slide changes
        addActiveClass(this);
      },
    },
  });
  const simpleCarousel = initSwiperWithLoopCheck(".simple-carousel", {
    slidesPerView: 4,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    // pagination: {
    //     el: '.swiper-pagination',  //Pagination element (dots)
    //     clickable: true,  //Makes the dots clickable for navigation
    // },
    breakpoints: {
      1024: {
        slidesPerView: 4,
      },
      769: {
        slidesPerView: 3,
      },
      600: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 2,
      },
    },
    on: {
      init: function () {
        // Called when Swiper is initialized
        addActiveClass(this); // Add the custom class to the active slide
      },
      slideChange: function () {
        // Called when the slide changes
        addActiveClass(this); // Update the custom class on the active slide
      },
    },
  });

  $(".additional-options-section-carousel .swiper").each(function (index) {
    // Create a unique identifier for each swiper and its navigation buttons
    const swiperId = `swiper-${index + 1}`;
    $(this).addClass(swiperId); // Add a unique class to each swiper instance
    $(this)
      .siblings(".swiper-button-next")
      .addClass(`swiper-button-next-${index + 1}`);
    $(this)
      .siblings(".swiper-button-prev")
      .addClass(`swiper-button-prev-${index + 1}`);

    // Count the number of slides in the current swiper
    const slideCount = $(this).find(".swiper-slide").length;
    // Enable loop mode only if the number of slides is greater than 4
    const shouldLoop = slideCount > 4;

    // Initialize Swiper for each slider with unique navigation buttons
    const swiperInstance = new Swiper(`.${swiperId}`, {
      slidesPerView: 4,
      spaceBetween: 0,
      loop: shouldLoop, // Set loop mode based on the number of slides
      navigation: {
        nextEl: `.swiper-button-next-${index + 1}`, // Unique next button for each swiper
        prevEl: `.swiper-button-prev-${index + 1}`, // Unique prev button for each swiper
      },
      // autoplay: {
      //     delay: 6000,
      //     disableOnInteraction: false,
      // },
      // pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true, //Enable clickable pagination dots
      // },
      breakpoints: {
        1024: { slidesPerView: 3 },
        600: { slidesPerView: 3 },
        450: { slidesPerView: 2 },
        320: { slidesPerView: 1 },
      },
    });
  });

  // Function to add a class to the first visible (active) slide
  function addActiveClass(swiperInstance) {
    // Loop through all slides and remove the 'first-slide' class
    swiperInstance.slides.forEach((slide) => {
      slide.classList.remove("first-slide");
    });

    // Add the 'first-slide' class to the current active slide
    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (activeSlide) {
      activeSlide.classList.add("first-slide");
    }
  }

  // Open fancybox with all swiper-gallery slides, starting at the clicked one
  $(".swiper-gallery").on("click", ".swiper-slide a", function (event) {
    event.preventDefault();

    var $slides = $(this).closest(".swiper-gallery").find(".swiper-slide a");
    var clickedIndex = $slides.index(this);

    var galleryItems = $slides.map(function () {
      return {
        src: $(this).attr("href"),
        type: "image",
        caption: $(this).data("caption") || "",
      };
    }).get();

    if (galleryItems.length > 0) {
      Fancybox.show(galleryItems, {
        startIndex: clickedIndex,
        infinite: true,
        Thumbs: { autoStart: true },
      });
    }
  });

  if (document.querySelector(".testimonial-swiper")) var testimonialSwiper = new Swiper(".testimonial-swiper", {
    slidesPerView: 2, // Show one testimonial at a time
    spaceBetween: 100, // Space between slides
    loop: true, // Infinite loop
    navigation: {
      nextEl: ".testimonial-next", // Next button for navigation
      prevEl: ".testimonial-prev", // Previous button for navigation
    },
    autoplay: {
      delay: 6000, // Slide changes every 5 seconds
      disableOnInteraction: false, // Autoplay continues even after user interaction
    },
    breakpoints: {
      992: {
        spaceBetween: 100,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      360: {
        slidesPerView: 1, // 3 slides visible for screens between 360px and 768px
      },
    },
  });

  //Set the initial image
  const firstImageSrc = $(".color-option.selected").data("image");
  $("#window-image").attr("src", firstImageSrc);

  $(".color-option").on("click", function () {
    //Remove the 'selected' class from all color variants
    $(".color-option").removeClass("selected");

    //Add the 'selected' class to the selected color
    $(this).addClass("selected");

    //We get data from the selected element
    const newImageSrc = $(this).data("image");
    const colorName = $(this).data("name");
    const colorArticule = $(this).data("articule");
    const iconSrc = $(this).data("icon");

    //Update the window image
    $("#window-image").attr("src", newImageSrc);

    //Update the content in the choose-colour block
    $(".choose-colour-name").text(colorName);
    $(".choose-colour-articule").text(colorArticule);
    $(".choose-colour-item").css("background-image", "url(" + iconSrc + ")");
  });

  $(".popup-youtube, .popup-vimeo").magnificPopup({
    disableOn: 0,
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
  });

  $(".btn-header").magnificPopup({
    items: {
      src: "#contact-popup",
      type: "inline",
    },
    mainClass: "mfp-fade",
    removalDelay: 160,
    fixedContentPos: true,
    callbacks: {
      open: function () {
        //Create a wrapper for the close button
        if (!$(".popup-container .mfp-close-wrap").length) {
          $(".popup-container").append('<div class="mfp-close-wrap"></div>');
        }
        //Move .mfp-close inside the new wrapper .mfp-close-wrap
        $(".mfp-close").appendTo(".popup-container .mfp-close-wrap");
      },
    },
  });

  // Event listener for the sprite button click
  $(".sprite-btn").on("click", function () {
    $.magnificPopup.open({
      items: {
        src: "#popup-content-infill", // Specifies the ID of the element to open in the popup
      },
      type: "inline", // Sets the popup type to inline content
      callbacks: {
        open: function () {
          // Get the background image URL from #window-image-sprite
          const currentImageUrl = $("#window-image-sprite")
            .css("background-image")
            .replace(/^url\(["']?/, "")
            .replace(/["']?\)$/, ""); // Remove url("...") formatting to get a clean URL

          // Set this URL as the data-sprite-url attribute for #swiper-wrapper
          $("#swiper-wrapper").attr("data-sprite-url", currentImageUrl);

          // Call initializeSpriteSwiper after the popup is opened
          initializeSpriteSwiper({
            swiperWrapperSelector:
              ".popup-content-infill-swiper #swiper-wrapper", // Swiper wrapper selector in the popup
            swiperContainerSelector: ".swiper-container", // Main Swiper container selector
            nextButtonSelector: ".swiper-button-next", // Selector for the next button in Swiper
            prevButtonSelector: ".swiper-button-prev", // Selector for the previous button in Swiper
            spriteImageUrl: currentImageUrl, // Pass the sprite image URL directly to initializeSpriteSwiper
            spriteCount: 14, // Total number of sprites in the image
            spritesPerSlide: 3, // Number of sprites to display per slide
            slidesPerView: 1, // Number of visible slides at once
            spaceBetween: 10, // Distance between slides in pixels
          });

          // Create a wrapper for the close button if it doesn't already exist
          if (!$(".popup-container .mfp-close-wrap").length) {
            $(".popup-container").append('<div class="mfp-close-wrap"></div>');
          }

          // Move .mfp-close into the new wrapper .mfp-close-wrap
          $(".mfp-close").appendTo(".popup-container .mfp-close-wrap");
        },
      },
    });
  });

  //Add a click handler for the color options
  $(".sprite-window-preview .color-option").on("click", function () {
    // Remove the 'selected' class from all color options
    $(".sprite-window-preview .color-option").removeClass("selected");

    //Add the 'selected' class to the selected color
    $(this).addClass("selected");

    // We get data from the selected element
    const newImageSrc = $(this).data("image"); //new image path
    const colorName = $(this).data("name"); //color name
    const colorArticule = $(this).data("articule"); //color article
    const iconSrc = $(this).data("icon"); //path to the icon
    const newSpriteRow = $(this).data("sprite-row"); //sprite-row value

    //Update the window image
    $("#window-image-sprite").css("background-image", `url(${newImageSrc})`);

    //Update the content in the choose-color block
    $(".choose-colour-name").text(colorName);
    $(".choose-colour-articule").text(colorArticule);
    $(".choose-colour-item").css("background-image", `url(${iconSrc})`);

    //Update the button class by deleting the previous sprite-row class and adding a new one
    $(".sprite-btn")
      .removeClass(function (index, className) {
        return (className.match(/(^|\s)sprite-row-\S+/g) || []).join(" ");
      })
      .addClass(newSpriteRow);

    //Update the data-sprite-url attribute in #swiper-wrapper
    $("#swiper-wrapper").attr("data-sprite-url", newImageSrc);

    //Restart Swiper with the new URL
    initializeSpriteSwiper({
      swiperWrapperSelector: "#swiper-wrapper",
      swiperContainerSelector: ".swiper-container",
      slidesPerView: 1,
      spaceBetween: 10,
      nextButtonSelector: ".swiper-button-next",
      prevButtonSelector: ".swiper-button-prev",
      spriteCount: 14,
      spritesPerSlide: 5,
    });
  });

  function initializeSpriteSwiper(options) {
    const $swiperWrapper = $(options.swiperWrapperSelector);
    const spriteImageUrl = options.spriteImageUrl;
    const spriteCount = options.spriteCount || 14;

    // Function to determine the number of sprites per slide based on screen width
    function getSpritesPerSlide() {
      if (window.innerWidth < 576) {
        return 1; // Show 1 sprite per slide if the screen width is less than 576px
      } else if (window.innerWidth < 768) {
        return 2; // Show 2 sprites per slide if the screen width is between 576px and 768px
      } else {
        return options.spritesPerSlide; // Use the default value for screen widths above 768px
      }
    }

    let spriteSwiper = null;

    // Function to initialize Swiper and set up sprites within each slide
    function initSwiper() {
      const spritesPerSlide = getSpritesPerSlide();

      // Destroy previous Swiper instance before reinitializing
      if (spriteSwiper) {
        spriteSwiper.destroy(true, true);
        spriteSwiper = null;
      }

      $swiperWrapper.empty(); // Clear any existing slides to prevent duplication

      for (let i = 0; i < Math.ceil(spriteCount / spritesPerSlide); i++) {
        const $slide = $("<div>").addClass("swiper-slide"); // Create a new slide

        for (let j = 0; j < spritesPerSlide; j++) {
          const spriteIndex = i * spritesPerSlide + j + 1;
          if (spriteIndex > spriteCount) break; // Stop if there are no more sprites to add

          const spriteClassName = `sprite_l_${spriteIndex}`;
          const $sprite = $("<div>")
            .addClass("sprite-image")
            .addClass(spriteClassName);

          // Set the background image for the sprite
          $sprite.css({
            "background-image": `url('${spriteImageUrl}')`,
          });

          // Add a click event to toggle the 'selected' class on click
          $sprite.on("click", function () {
            $(this).toggleClass("selected");
          });

          $slide.append($sprite); // Add the sprite to the current slide
        }

        $swiperWrapper.append($slide); // Add the slide to the swiper wrapper
      }

      // Initialize Swiper with options
      spriteSwiper = new Swiper(options.swiperContainerSelector, {
        slidesPerView: 1,
        spaceBetween: options.spaceBetween || 10,
        navigation: {
          nextEl: options.nextButtonSelector,
          prevEl: options.prevButtonSelector,
        },
      });
    }

    // Call initSwiper initially when the function runs
    initSwiper();

    // Use namespaced event to avoid stacking handlers on repeated calls
    $(window).off("resize.spriteSwiper").on("resize.spriteSwiper", function () {
      initSwiper();
    });
  }

  //Add a click handler for sprites inside the popup
  $(document).on(
    "click",
    ".popup-content-infill-swiper .sprite-image",
    function () {
      const spriteClass = $(this)
        .attr("class")
        .split(" ")
        .find((c) => c.startsWith("sprite_l_"));

      if (spriteClass) {
        $("#window-image-sprite").removeClass(function (index, className) {
          return (className.match(/(^|\s)sprite_l_\S+/g) || []).join(" ");
        });

        $("#window-image-sprite").addClass(spriteClass);
        // Close the popup
        $.magnificPopup.close();
      }
    }
  );

  // Set the initial background color for the window image
  const firstColor = $(".color-window-preview .color-option.selected").data(
    "color"
  );
  $(".color-window-preview-image img").css("background", firstColor);

  // Add a click handler for color options
  $(".color-window-preview .color-option").on("click", function () {
    // Remove the 'selected' class from all color options
    $(".color-option").removeClass("selected");

    // Add the 'selected' class to the clicked color option
    $(this).addClass("selected");

    // Retrieve data from the selected element
    const newColor = $(this).data("color"); // Get the color value
    const colorName = $(this).data("name");
    const colorArticule = $(this).data("articule");

    // Update the window image background color
    $("#window-image").css("background", newColor);

    // Update the content in the choose-colour block
    $(".choose-colour-name").text(colorName);
    $(".choose-colour-articule").text(colorArticule);
    $(".choose-colour-item").css("background", newColor);
  });

  if (document.querySelector(".comparison-product-carousel")) var swiperComparisonCarousel = new Swiper(".comparison-product-carousel", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true, // Infinite loop
    loopedSlides: 2,
    navigation: { 
      nextEl: ".comparison-next", // Next button for navigation
      prevEl: ".comparison-prev", // Previous button for navigation
    }, 
    autoplay: {
      delay: 6000, // Slide changes every 5 seconds
      disableOnInteraction: false, // Autoplay continues even after user interaction
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
      475: {
        slidesPerView: 2,
      },
    },
  });

  //Function to align the height of elements with the same classes
  function setEqualHeightByClass(className) {
    var elements = $("." + className);
    var maxHeight = 0;

    //Find the maximum height among elements with this class
    elements.each(function () {
      var elementHeight = $(this).outerHeight();
      if (elementHeight > maxHeight) {
        maxHeight = elementHeight;
      }
    });

    //Set the maximum height for all elements with this class
    elements.css("height", maxHeight + "px");
  }

  //Iterate over each comparison-item class (1-7)
  for (var i = 1; i <= 7; i++) {
    setEqualHeightByClass("comparison-item-" + i);
  }

  //Execution of the function when the window is resizedis resized
  $(window).on("resize", function () {
    //First reset the height to adapt to the new window size
    for (var i = 1; i <= 7; i++) {
      $(".comparison-section .comparison-item-" + i).css("height", "auto");
    }

    //Apply height alignment again
    for (var i = 1; i <= 7; i++) {
      setEqualHeightByClass("comparison-item-" + i);
    }
  });
  //Function to show/hide "Technical data" on mobile
  function toggleTechnicalData() {
    $(".technical-data").toggleClass("hidden");
    if ($(".technical-data").hasClass("hidden")) {
      setTimeout(function () {
        $(".toggle-technical-data-icon").addClass("active");
      }, 300);
    } else {
      $(".toggle-technical-data-icon").removeClass("active");
    }
  }
  $(".toggle-technical-data-icon").on("click", function () {
    toggleTechnicalData();
  });

  $(".comparison-product-carousel").on("click", ".swiper-slide", function () {
    if ($(".technical-data").hasClass("hidden")) {
      $(".technical-data").removeClass("hidden");
      $(".toggle-technical-data-icon").removeClass("active");
    }
  });

  if (document.querySelector(".glass-section-carousel .swiper")) var swiperGlassCarousel = new Swiper(".glass-section-carousel .swiper", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      620: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1300: {
        slidesPerView: 4,
      },
    },
  });

  if (document.querySelector(".glass-section-carousel.handles-carousel .swiper")) var swiperHandlesCarousel = new Swiper(".glass-section-carousel.handles-carousel .swiper", {
    slidesPerView: 2,
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      620: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 5,
      },
    },
  });

  if (document.querySelector(".our-partners-swiper")) var swiper = new Swiper(".our-partners-swiper", {
    direction: "horizontal",
    loop: true,
    navigation: {
      nextEl: ".c-carousel__button--next",
      prevEl: ".c-carousel__button--prev",
    },
    breakpoints: {
      475: {
        slidesPerView: 2,
      },
      720: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 5,
      },
    },
    spaceBetween: 24,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    speed: 600,
    loopAdditionalSlides: 1,
    slidesPerGroup: 1,
  });

  // Handles group
  Fancybox.bind('[data-fancybox="additional-options-handles"]', {
    loop: true,
    arrows: true,
    Thumbs: { autoStart: true },
  });

  Fancybox.bind(`[data-fancybox="additional-inne-options-open"]`, {
    loop: true, // Enable looping within each gallery
    arrows: true, // Show navigation arrows
    Thumbs: { autoStart: true }, // Automatically show thumbnails
  });
  // //Initialize all other groups
  const uniqueFancyboxGroups = [
    ...new Set(
      $("[data-fancybox]")
        .map(function () {
          const fancyboxValue = $(this).data("fancybox");
          return fancyboxValue.startsWith("gallery-additional-options")
            ? fancyboxValue
            : null;
        })
        .get()
    ),
  ];

  uniqueFancyboxGroups.forEach((group) => {
    Fancybox.bind(`[data-fancybox="${group}"]`, {
      loop: true,
      arrows: true,
      Thumbs: { autoStart: true },
    });
  });

  document.querySelectorAll('[data-fancybox^="our-works-cat"]').forEach((el) => {
    el.addEventListener('click', function (e) {
      e.preventDefault();

      const group = el.getAttribute('data-fancybox');
      const items = document.querySelectorAll(`[data-fancybox="${group}"]`);

      const slides = Array.from(items).map((item) => ({
        src: item.getAttribute('href'),
        thumb: item.querySelector('img')?.getAttribute('src') || '',
        caption: item.getAttribute('data-caption') || '',
      }));

      //First we open
      const instance = Fancybox.show(slides, {
        Hash: false,
        Thumbs: { autoStart: true },
      });

      //Through 50ms we close
      setTimeout(() => {
        const currentIndex = instance.getSlide().index;
        instance.close();

        //Even after 50ms -Open again (with Caption already revised)
        setTimeout(() => {
          Fancybox.show(slides, {
            startIndex: currentIndex,
            Hash: false,
            Thumbs: { autoStart: true },
          });
        }, 50);
      }, 50);
    });
  });



  $('.filter-btn').on('click', function () {
    let term = $(this).data('term');

    $('.filter-btn').removeClass('active');
    $(this).addClass('active');

    $.ajax({
      url: ajax_object.ajaxurl,
      type: 'POST',
      data: {
        action: 'filter_our_works',
        nonce: ajax_object.nonce,
        term: term
      },
      success: function (response) {
        $('.gallery-our-works-items').html(response);
        Fancybox.bind("[data-fancybox]", {});
      },
      error: function (xhr, status, error) {
        console.error('AJAX error: ', error);
        console.log(xhr.responseText);
      }
    });
  });
});


document.addEventListener('click', function (e) {
  const btn = e.target.closest('.faq-acc__btn');
  if (!btn) return;

  const item = btn.closest('.faq-acc__item');
  const panel = item.querySelector('.faq-acc__panel');
  const inner = item.querySelector('.faq-acc__panel-inner');

  if (!panel || !inner) return;

  const isOpen = item.classList.contains('is-open');

  // helper: close with animation
  const closeItem = (it) => {
    const b = it.querySelector('.faq-acc__btn');
    const p = it.querySelector('.faq-acc__panel');
    const inr = it.querySelector('.faq-acc__panel-inner');
    if (!p || !inr) return;

    it.classList.remove('is-open');
    if (b) b.setAttribute('aria-expanded', 'false');

    p.hidden = false; // for the animation to work
    p.style.height = inr.scrollHeight + 'px';
    p.offsetHeight; // Reflow
    p.style.transition = 'height .25s ease';
    p.style.height = '0px';

    p.addEventListener('transitionend', function te() {
      p.hidden = true;
      p.style.height = '';
      p.style.transition = '';
      p.removeEventListener('transitionend', te);
    });
  };

  // helper: open with animation
  const openItem = (it) => {
    const b = it.querySelector('.faq-acc__btn');
    const p = it.querySelector('.faq-acc__panel');
    const inr = it.querySelector('.faq-acc__panel-inner');
    if (!p || !inr) return;

    it.classList.add('is-open');
    if (b) b.setAttribute('aria-expanded', 'true');

    p.hidden = false;
    p.style.height = '0px';
    p.offsetHeight; // Reflow
    p.style.transition = 'height .25s ease';
    p.style.height = inr.scrollHeight + 'px';

    p.addEventListener('transitionend', function te() {
      p.style.height = '';
      p.style.transition = '';
      p.removeEventListener('transitionend', te);
    });
  };

  // close all other open ones
  document.querySelectorAll('.faq-acc__item.is-open').forEach((openIt) => {
    if (openIt !== item) closeItem(openIt);
  });

  // toggle current
  if (isOpen) {
    closeItem(item);
  } else {
    openItem(item);
  }
});




// //when the page is fully loaded
// window.addEventListener('load', initAll);


function getColumnsCountByGrid(grid) {
  const w = grid.clientWidth; // important: by container, not by window
  if (w <= 640) return 1;
  if (w <= 1200) return 2;
  return 3;
}

function buildMasonry(grid) {
  if (!grid) return;

  // 1) if it has already been initialized, disassemble it back
  const existingCols = grid.querySelectorAll(':scope > .grv-col');
  if (existingCols.length) {
    const cards = [];
    existingCols.forEach(col => {
      col.querySelectorAll(':scope > .grv-card').forEach(card => cards.push(card));
    });
    existingCols.forEach(col => col.remove());
    cards.forEach(card => grid.appendChild(card));
  }

  const cards = Array.from(grid.querySelectorAll(':scope > .grv-card'));
  if (!cards.length) return;

  const colsCount = getColumnsCountByGrid(grid);

  // 2) create columns
  const cols = [];
  for (let i = 0; i < colsCount; i++) {
    const col = document.createElement('div');
    col.className = 'grv-col';
    cols.push(col);
    grid.appendChild(col);
  }

  // 3) MEASURE the height of the cards at the width of the column + sort (key)
  // we make an invisible meter with the width of the column
  const gap = 28;
  const colWidth = Math.floor((grid.clientWidth - gap * (colsCount - 1)) / colsCount);

  const measurer = document.createElement('div');
  measurer.style.cssText = `
    position:absolute;
    left:-99999px;
    top:0;
    width:${colWidth}px;
    visibility:hidden;
    pointer-events:none;
  `;
  document.body.appendChild(measurer);

  const measured = cards.map(card => {
    const clone = card.cloneNode(true);
    measurer.appendChild(clone);
    const h = clone.getBoundingClientRect().height || 0;
    measurer.removeChild(clone);
    return { card, h };
  });

  document.body.removeChild(measurer);

  // big ones first
  measured.sort((a, b) => b.h - a.h);

  // 4) layout: in the lowest column
  measured.forEach(({ card }) => {
    const shortest = cols.reduce((a, b) => (a.offsetHeight <= b.offsetHeight ? a : b));
    shortest.appendChild(card);
  });
}

function initAll() {
  document.querySelectorAll('.google-reviews--grid .grv-grid').forEach(buildMasonry);
}

// debounce resize
let t = null;
window.addEventListener('resize', () => {
  clearTimeout(t);
  t = setTimeout(() => requestAnimationFrame(initAll), 150);
});

// Start
document.addEventListener('DOMContentLoaded', () => requestAnimationFrame(initAll));
window.addEventListener('load', () => requestAnimationFrame(initAll));

// fonts (affect height)
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(() => requestAnimationFrame(initAll)).catch(() => { });
}

document.addEventListener("DOMContentLoaded", () => {

  const headerOffset = 20; // твій offset

  const items = document.querySelectorAll(".toc__item");

  const sections = [];

  items.forEach(item => {
    const link = item.querySelector(".toc__link");
    if (!link) return;

    const id = link.getAttribute("href");
    const section = document.querySelector(id);
    if (!section) return;

    sections.push({
      id,
      item,
      section
    });
  });

  const activate = (currentId) => {
    items.forEach(i => i.classList.remove("is-active"));

    const active = sections.find(s => s.id === currentId);
    if (active) {
      active.item.classList.add("is-active");
    }
  };

  // 🔹 Smooth scroll
  document.addEventListener("click", (e) => {
    const a = e.target.closest(".toc__link");
    if (!a) return;

    const id = a.getAttribute("href");
    const target = document.querySelector(id);
    if (!target) return;

    e.preventDefault();

    const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

    window.scrollTo({ top, behavior: "smooth" });

    activate(id); // одразу активуємо при кліку
  });

  // 🔹 Scroll spy
  const onScroll = () => {
    let current = null;

    sections.forEach(({ id, section }) => {
      const rect = section.getBoundingClientRect();

      if (rect.top - headerOffset <= 0) {
        current = id;
      }
    });

    if (current) {
      activate(current);
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("load", onScroll);

  onScroll();
});

document.addEventListener("DOMContentLoaded", () => {
  const mq = window.matchMedia("(min-width: 992px)");

  const stickyEl = document.querySelector(".blog-single__sidebar-sticky");
  const sidebar = document.querySelector(".blog-single__sidebar");
  const container = document.querySelector(".blog-single__inner");

  const root = document.querySelector(".blog-single__body");

  const TOP = 24;

  let stickyBound = false;

  const stickyReset = () => {
    if (!stickyEl) return;
    stickyEl.classList.remove("is-fixed", "is-stopped");
    stickyEl.style.position = "";
    stickyEl.style.top = "";
    stickyEl.style.left = "";
    stickyEl.style.width = "";
    stickyEl.style.transform = "";
  };

  const stickyRecompute = () => {
    const y = window.pageYOffset;

    const cRect = container.getBoundingClientRect();
    const cTop = cRect.top + y;
    const cBottom = cTop + container.offsetHeight;

    const sRect = sidebar.getBoundingClientRect();
    const sLeft = sRect.left;
    const sWidth = sRect.width;

    const elH = stickyEl.offsetHeight;

    return { y, cTop, cBottom, sLeft, sWidth, elH };
  };

  const stickySetFixed = (left, width) => {
    stickyEl.classList.add("is-fixed");
    stickyEl.classList.remove("is-stopped");
    stickyEl.style.position = "fixed";
    stickyEl.style.top = `${TOP}px`;
    stickyEl.style.left = `${left}px`;
    stickyEl.style.width = `${width}px`;
    stickyEl.style.transform = "";
  };

  const stickySetStopped = (left, width, translateY) => {
    stickyEl.classList.add("is-stopped");
    stickyEl.classList.remove("is-fixed");
    stickyEl.style.position = "fixed";
    stickyEl.style.top = `${TOP}px`;
    stickyEl.style.left = `${left}px`;
    stickyEl.style.width = `${width}px`;
    stickyEl.style.transform = `translateY(${translateY}px)`;
  };

  const stickyOnScroll = () => {
    if (!mq.matches) return;

    const { y, cTop, cBottom, sLeft, sWidth, elH } = stickyRecompute();

    if (y < cTop - TOP) {
      stickyReset();
      return;
    }

    const maxScrollInside = (cBottom - cTop) - elH;
    const passed = (y + TOP) - cTop;

    if (passed >= maxScrollInside) {
      stickySetStopped(sLeft, sWidth, Math.max(0, maxScrollInside));
    } else {
      stickySetFixed(sLeft, sWidth);
    }
  };

  // ---- OL start normalization (>=992 only)
  const normalizeOlStarts = () => {
    if (!mq.matches) return;
    if (!root) return;

    const lists = Array.from(root.querySelectorAll("ol.wp-block-list"));
    if (!lists.length) return;

    let n = 1;
    lists.forEach((ol) => {
      const items = ol.querySelectorAll(":scope > li");
      if (!items.length) return;

      ol.setAttribute("start", String(n));
      n += items.length;
    });
  };

  const enable = () => {
    // sticky
    if (stickyEl && sidebar && container && !stickyBound) {
      window.addEventListener("scroll", stickyOnScroll, { passive: true });
      window.addEventListener("load", stickyOnScroll);
      stickyBound = true;
      stickyOnScroll();
    }

    // lists
    normalizeOlStarts();
  };

  const disable = () => {
    // sticky reset (і не даємо фіксації на мобілці)
    stickyReset();
  };

  // init
  if (mq.matches) enable();
  else disable();

  // реагуємо на зміну ширини
  mq.addEventListener("change", (e) => {
    if (e.matches) {
      enable();
    } else {
      disable();
    }
  });

  // якщо треба перераховувати при ресайзі на десктопі
  window.addEventListener("resize", () => {
    if (!mq.matches) return;
    stickyReset();
    stickyOnScroll();
    normalizeOlStarts();
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const root = document.querySelector(".blog-single__body");
  if (!root) return;

  const lists = Array.from(root.querySelectorAll("ol.wp-block-list"));
  if (!lists.length) return;

  let n = 1;

  lists.forEach((ol) => {
    const items = ol.querySelectorAll(":scope > li");
    if (!items.length) return;

    // ставимо правильний start
    ol.setAttribute("start", String(n));

    // збільшуємо лічильник на кількість li
    n += items.length;
  });
});
